/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'WorkTime',dictionary:{"de":{"times":{"start":"Start","end":"Ende"}},"en":{"times":{"start":"Start","end":"End"}}}})
import { Login } from './Login';
import { Worker } from './Worker';
import { ProjectTimeReport } from './ProjectTimeReport';
import { WorkerTimeReport } from './WorkerTimeReport';

export class WorkTime extends _BaseModel {
	
	static toString() {
		return 'WorkTime'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkTime.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkTime', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkTime.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkTime', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkTime.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkTime', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkTime.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkTime', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkTime'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkTime) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'meta.currentDocument'}) ],
				model: WorkTime,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkTime', path:'meta.revisions'}) ],
				model: WorkTime,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	worker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				itemText: "references.person.__getters.lastFirstName",
				optionName: "person",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'references.worker'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
					
	projectTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'references.projectTimeReport'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
					
	workerTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerTimeReport) || _BaseModel.t('rules.reference', {modelName:'WorkTime', path:'references.workerTimeReport'}) ],
				model: WorkerTimeReport,
				returnObject: true,
},
    
	},
	
},
			times: 				{
					
	start:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkTime.times.start'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkTime', path:'times.start'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkTime', path:'times.start'}) ],
},
    __isDateTime: true,
	},
	
					
	end:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkTime.times.end'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkTime', path:'times.end'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkTime', path:'times.end'}) ],
},
    __isDateTime: true,
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkTime._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, times={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.times=TimesClass.create(times);
		this._id=_id;
	}

	static create(data) {
		return new WorkTime(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof WorkTime || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : WorkTime.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof WorkTime ? item : WorkTime.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({worker=undefined, projectTimeReport=undefined, workerTimeReport=undefined, }={}){
		this.worker= (worker instanceof Worker || typeof worker === 'string' || !worker) ? worker : Worker.create(worker);
		this.projectTimeReport= (projectTimeReport instanceof ProjectTimeReport || typeof projectTimeReport === 'string' || !projectTimeReport) ? projectTimeReport : ProjectTimeReport.create(projectTimeReport);
		this.workerTimeReport= (workerTimeReport instanceof WorkerTimeReport || typeof workerTimeReport === 'string' || !workerTimeReport) ? workerTimeReport : WorkerTimeReport.create(workerTimeReport);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class TimesClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new TimesClass(data);
	}
}
